export default defineAppConfig({
  name: 'Riven Bot Admin',
  version: 'v1.0.1',
  ui: {
    icons: {
      system: 'i-heroicons-computer-desktop',
      light: 'i-heroicons-sun',
      dark: 'i-heroicons-moon'
    }
  }
})
